export default __webpack_public_path__ + "static/media/apicbase application.97f722cf.png";